export class Cone {
    get Removed() {
        return this.removed;
    }
    set Removed(value) {
        this.removed = value;
    }
    constructor(apex, coneSweeper) {
        this.apex = apex;
        this.coneSweeper = coneSweeper;
    }
    get Apex() {
        return this.apex;
    }
    set Apex(value) {
        this.apex = value;
    }
    get RightSideDirection() {
        return this.coneSweeper.ConeRightSideDirection;
    }
    get LeftSideDirection() {
        return this.coneSweeper.ConeLeftSideDirection;
    }
    get RightSide() {
        return this.rightSide;
    }
    set RightSide(value) {
        this.rightSide = value;
        this.rightSide.Cone = this;
    }
    get LeftSide() {
        return this.leftSide;
    }
    set LeftSide(value) {
        this.leftSide = value;
        this.leftSide.Cone = this;
    }
}
//# sourceMappingURL=Cone.js.map